<template>
    <div class="b-modal__promocode-text">
        <div class="b-modal__promocode-title">
            {{ option.title }}
        </div>

        <div class="b-modal__promocode-date">Срок действия до {{ date }}</div>

        <div class="b-modal__promocode-wrap">
            <div class="b-modal__promocode-value">
                <div id="b-modal__promocode-field">{{ promoCode }}</div>

                <button class="b-copyButton" onclick="ym(93668485,'reachGoal','copypromo')" @click="copyCode">
                    <img src="/images/icon-copy.svg">
                </button>
            </div>

            <div v-show="message" class="b-modal__promocode-message">{{ message }}</div>
        </div>

        <div class="b-modal__promocode-subtitle">
            <div v-html="option.description"></div>
        </div>

        <div v-show="option.url">
            <a target="_blank" class="b-modal__promocode-button button" onclick="ym(93668485,'reachGoal','opensite_promo')" :href="option.url">Перейти</a>
        </div>
    </div>
</template>

<script>
import useEvents from '../composables/events';

import {onMounted, ref} from 'vue';

export default {
    name: 'EventPromoCodes',
    props: {
        option: {
            required: true,
            type: Object,
        },
        date: {
            required: true,
            type: String,
        },
        unique: {
            required: true,
            type: Boolean
        }
    },
    setup(props) {
        const { getUniquePromoCode } = useEvents()
        let promoCode = ref(props.option.promo_code);
        let copied = ref(false);
        let message = ref('');

        const copyCode = () => {
            navigator.clipboard.writeText(promoCode.value);
            message.value = 'Код скопирован!';
        }

        const getCode = async () => {
            const data = await getUniquePromoCode();

            if(data.success) {
                promoCode.value = data.promo_code;
            } else {
                message.value = 'Произошла ошибка';
            }
        }

        onMounted(() => {
            if(props.unique) {
                getCode();
            }
        })

        return {message, promoCode, copied, copyCode, getCode};
    }
};
</script>

<style scoped>

</style>